import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-702847f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-fixed-header" }
const _hoisted_2 = { class: "chart-header" }
const _hoisted_3 = { class: "chart-title" }
const _hoisted_4 = { class: "time-filters" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "chart-legend"
}
const _hoisted_7 = { class: "legend-item" }
const _hoisted_8 = { class: "legend-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line benchmark-line" }, null, -1))
const _hoisted_10 = { class: "chart-body" }
const _hoisted_11 = {
  key: 0,
  class: "chart-loading"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loading-dot" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "chart-empty"
}
const _hoisted_15 = {
  key: 2,
  class: "chart-container",
  ref: "chartRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nodata = _resolveComponent("Nodata")!

  return (_openBlock(), _createElementBlock("div", {
    class: "yield-chart",
    style: _normalizeStyle({
    '--yc-bg':             _ctx.chartVars.bg,
    '--yc-header-text':    _ctx.chartVars.headerText,
    '--yc-text-sub':       _ctx.chartVars.textSub,
    '--yc-text-pri':       _ctx.chartVars.textPri,
    '--yc-border':         _ctx.chartVars.border,
    '--yc-benchmark-line': _ctx.chartVars.benchmarkLine,
    '--yc-spin-border':    _ctx.chartVars.spinBorder,
    '--yc-spin-top':       _ctx.chartVars.spinTop,
  })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.tran('收益走势')), 1),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeOptions, (t) => {
            return (_openBlock(), _createElementBlock("span", {
              key: t.value,
              class: _normalizeClass(['time-btn', { active: _ctx.currentRange === t.value }]),
              onClick: ($event: any) => (_ctx.changeRange(t.value))
            }, _toDisplayString(t.label), 11, _hoisted_5))
          }), 128))
        ])
      ]),
      (_ctx.hasData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createElementVNode("span", {
                class: "line",
                style: _normalizeStyle({ background: _ctx.legendStrategyColor })
              }, null, 4),
              _createTextVNode(" " + _toDisplayString(_ctx.tran('本策略')) + " ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["legend-value", _ctx.legendStrategyValueClass])
              }, _toDisplayString(_ctx.legendStrategyValue), 3)
            ]),
            _createElementVNode("span", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.benchmarkName) + " ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["legend-value", _ctx.legendBenchmarkValueClass])
              }, _toDisplayString(_ctx.legendBenchmarkValue), 3)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
        : (!_ctx.hasData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_Nodata, {
                mode: "vertical",
                customdesc: _ctx.tran('暂无收益率'),
                pagetheme: _ctx.isDark ? 'dark' : 'light'
              }, null, 8, ["customdesc", "pagetheme"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, null, 512))
    ])
  ], 4))
}